<div class="modal-header">
  <h3 class="modal-title">
    {{ ("data.edit_trailer" | translate) + " '" + trailer?.remorqueId + "'" }}
  </h3>
  <button type="button" aria-label="Close" (click)="closeModal()">
    <i class="fa fa-close"></i>
  </button>
</div>
<div class="modal-body">
  <div class="main-card mb-3 card">
    <div class="card-body">
      <div class="row mb-5">
        <div class="col-md-12">
          <form [formGroup]="form">
            <div class="row form-group justify-content-center">
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="collectorPickUp" class="">
                    {{ "data.enter_collector" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="selectedTransportor"
                    name="selectedTransportor"
                    id="selectedTransportor"
                  >
                    <option [ngValue]="undefined">
                      {{ "data.select_collect" | translate }}
                    </option>
                    <option
                      [value]="collector._id"
                      *ngFor="let collector of collectorList"
                    >
                      {{ collector.nameSociety }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('selectedTransportor').touched &&
                      form.get('selectedTransportor').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="collectorPickUp" class="">
                    {{ "data.Transport_type" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="transportorType"
                    name="transportorType"
                    id="transportorType"
                  >
                    <option [ngValue]="undefined">
                      {{ "data.select_collect" | translate }}
                    </option>
                    <option
                      [value]="item"
                      *ngFor="let item of transportorTypes"
                    >
                      {{ item }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('transportorType').touched &&
                      form.get('transportorType').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group justify-content-center">
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="remorqueId" class="">
                    {{ "data.trailer_number" | translate }} :
                  </legend>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="remorqueId"
                    name="remorqueId"
                    id="remorqueId"
                    placeholder="Ex: Remorque ID"
                  />
                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('remorqueId').touched &&
                      form.get('remorqueId').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="position-relative form-group">
                  <legend for="plateform" class="">
                    {{ "data.plateform" | translate }} :
                  </legend>
                  <select
                    class="form-control selectric"
                    formControlName="plateform"
                    name="plateform"
                    id="plateform"
                  >
                    <option [ngValue]="undefined">Select a plateform</option>
                    <option
                      [value]="plateform"
                      *ngFor="let plateform of plateformList"
                    >
                      {{ plateform }}
                    </option>
                  </select>

                  <div
                    class="text-danger mt-1"
                    *ngIf="
                      form.get('plateform').touched &&
                      form.get('plateform').invalid
                    "
                  >
                    {{ "data.field_required" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="main-card mb-3 card">
            <div class="card-header-tab card-header">
              <div class="card-header-title">
                <i
                  class="header-icon lnr-rocket icon-gradient bg-tempting-azure"
                >
                </i>
                {{ "data.add_new_pickup" | translate }}
              </div>
              <div class="btn-actions-pane-right">
                <div class="position-relative">
                  <input
                    type="text"
                    name="pickup"
                    id="pickup"
                    class="form-control"
                    #autoInput
                    matInput
                    [matAutocomplete]="auto"
                    (input)="onChange()"
                    size="70"
                  />

                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="onSelectionChange($event)"
                  >
                    <mat-option *ngFor="let item of pickupsList" [value]="item">
                      {{ item?.ref_facture_cmd }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table
              class="align-middle mb-0 table table-borderless table-striped table-hover"
            >
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th>{{ "data.provider" | translate }}</th>
                  <th>{{ "data.reference" | translate }}</th>
                  <th>{{ "data.creation_date" | translate }}</th>
                  <th class="text-center">
                    {{ "data.products" | translate }}<br />
                    {{ "data.quantity_product_name" | translate }}
                  </th>
                  <th class="text-center">
                    {{ "data.volume" | translate }}<br />(m³)
                  </th>
                  <th class="text-center">
                    {{ "data.total_weight" | translate }}<br />(Kg)
                  </th>
                  <th class="text-center">
                    {{ "data.total" | translate }}<br />(€)
                  </th>
                  <th class="text-center" data-width="100">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let cmd of selectedCmds; let index = index">
                  <td class="text-center text-muted">#{{ index + 1 }}</td>
                  <td>
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="widget-content-left">
                            <ngx-avatar
                              class="rounded-circle"
                              name="{{ cmd?.client_cmd?.prenom_client }}
                                                {{
                                cmd?.client_cmd?.nom_client
                              }}"
                            >
                            </ngx-avatar>
                          </div>
                        </div>
                        <div class="widget-content-left flex2">
                          <div class="widget-heading">
                            {{ cmd?.client_cmd?.providerName }}
                          </div>
                          <div class="widget-subheading opacity-7">
                            {{ cmd?.client_cmd?.shippingAdress?.label_target }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{{ cmd?.ref_facture_cmd }}</td>
                  <td>
                    {{ cmd?.date_creation_cmd | date: "d MMM y" }}<br />
                    <b>{{ cmd?.date_creation_cmd | date: "HH:mm" }}</b>
                  </td>
                  <td>
                    <ul
                      class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                      *ngIf="cmd?.totalBoxes > 0"
                    >
                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left mr-3 widget-pallet">
                              <img
                                width="100%"
                                src="https://assets.marketbey.tn/WTM/products/box.png"
                                alt=""
                              />
                            </div>
                            <div class="widget-content-right">
                              <div class="font-size-lg text-muted">
                                <span>
                                  {{
                                    cmd?.totalBoxes -
                                      (cmd?.etat_cmd == "partially_received" &&
                                      cmd?.totalBoxesReceived
                                        ? cmd?.totalBoxesReceived
                                        : 0)
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul
                      class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                      *ngIf="cmd?.totalPallets > 0"
                    >
                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left mr-3 widget-pallet">
                              <img
                                width="100%"
                                src="https://assets.marketbey.tn/WTM/products/pallet.png"
                                alt=""
                              />
                            </div>
                            <div class="widget-content-right">
                              <div class="font-size-lg text-muted">
                                <span>
                                  {{
                                    cmd?.totalPallets -
                                      (cmd?.etat_cmd == "partially_received" &&
                                      cmd?.totalPalletsReceived
                                        ? cmd?.totalPalletsReceived
                                        : 0)
                                  }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </td>
                  <td class="text-center">
                    <!-- {{
                      cmd?.totalPalletVolume -
                        (cmd?.etat_cmd == "partially_received" &&
                        cmd?.totalPalletVolumeReceived
                          ? cmd?.totalPalletVolumeReceived
                          : 0) | number : "0.1"
                    }} -->
                    {{ cmd?.totalVolume | number: "0.1" }}
                  </td>
                  <td class="text-center">
                    <div *ngIf="cmd?.etat_cmd !== 'partially_received'">
                      {{ cmd?.totalPoids | number: "0.1" }}
                    </div>
                  </td>
                  <td class="text-center">
                    {{ cmd?.total_ca_cmd | number: "0.3" }} EUR
                  </td>
                  <td>
                    <button
                      type="button"
                      (click)="deleteTrailer(cmd?._id)"
                      tabindex="0"
                      class="dropdown-item"
                    >
                      <i class="metismenu-icon pe-7s-trash text-danger"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
    {{ "data.close" | translate }}
  </button>

  <div *ngIf="isClicked; else elseIsSaved">
    <div class="spinner-container blue-spinner">
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="40"
        [strokeWidth]="5"
      ></mat-progress-spinner>
    </div>
  </div>
  <ng-template #elseIsSaved>
    <button type="button" class="btn btn-success" (click)="update()">
      Valider la réception
    </button>
  </ng-template>
</div>
